// Phase C.5b — pure recurrence helpers for the Practice/Other "Repeat
// this event" UX (components/teams/GameFormDialogs.js). Kept plain (no
// React) so this logic is unit-testable without a brittle component
// test — see recurrence.test.js. V1 is weekly-only by design (044's own
// header) — nothing here anticipates monthly/nth-weekday/RRULE.

export const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Same timezone-safe pattern established throughout this codebase
// (utils/teamSchedule.js's own parseLocalDate): a bare 'new Date(str)'
// parses as UTC midnight and can land on the previous local day. This
// also matches Postgres's own extract(dow from date) convention exactly
// (0 = Sunday) — a weekday checked in this UI and the weekday
// create_recurring_event() (044) computes server-side always agree.
function parseLocalDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** 0 (Sunday) .. 6 (Saturday) for a 'YYYY-MM-DD' date string, or null
 * for an empty/missing date — used to auto-check the matching weekday
 * the moment a coach picks a start date for a new recurring event. */
export function weekdayOfDateString(dateStr) {
  if (!dateStr) return null;
  return parseLocalDate(dateStr).getDay();
}

/** Matches 044's own server-side cap exactly — a full football season's
 * worth of practices, comfortably, and small enough that a runaway
 * "repeat forever" typo is rejected outright rather than silently
 * truncated. */
export const MAX_RECURRENCE_WEEKS = 26;

/** The latest Until date this UI will let a coach pick before the
 * server's own generation cap (044) would reject it outright — one
 * place for that day-count math so the date picker can bound itself
 * without duplicating it. Returns null when there's no start date yet. */
export function maxRecurrenceUntilDate(startDateStr) {
  if (!startDateStr) return null;
  const start = parseLocalDate(startDateStr);
  const max = new Date(start.getFullYear(), start.getMonth(), start.getDate() + MAX_RECURRENCE_WEEKS * 7);
  const mm = String(max.getMonth() + 1).padStart(2, '0');
  const dd = String(max.getDate()).padStart(2, '0');
  return `${max.getFullYear()}-${mm}-${dd}`;
}
